import * as update from './update.svg';
import * as _switch from './switch.svg';

export { update, _switch };
